import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { Header } from '../header';
import { LoadingView } from '../loading-view';
export const DefaultLayout = () => {
    return (_jsxs("section", { children: [_jsx(Header, {}), _jsx(Suspense, { fallback: _jsx(LoadingView, { height: "100%" }), children: _jsx(Outlet, {}) })] }));
};
